module.exports = __webpack_public_path__ + "img/ai1.1a694015.jpg";